















import { Component, Vue } from 'vue-property-decorator';

@Component

export default class GamblingPage extends Vue {
  private msg: string = 'ecommercepage'
  private created() {
    console.log(this.msg)
    this.$vuetify.theme.dark = false
  }
}
